export enum RefreshPageActions {
  SET_REFRESH_PAGE = 'SET_REFRESH_PAGE',
}
